// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"932":"1ef5e24f","953":"9825655c"}[chunkId] + ".js";
};